// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinMpayroll = createAsyncThunk(
  "mpayroll/getMin",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterMpayroll",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        let newObj = [];
        response.data.data.map((item) =>
          newObj.push({
            value: item.MpayrollID,
            label: item.NamaMpayroll,
          })
        );
        return { data: newObj };
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const getMpayroll = createAsyncThunk(
  "mpayroll/get",
  async ({ start, count, search, tipekaryawan }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    formData.append("tipekaryawan", tipekaryawan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMasterPayroll",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const insertMpayroll = createAsyncThunk(
  "mpayroll/insert",
  async (
    {
      Nik,
      UpahPokok,
      Keahlian,
      JkIN,
      JkOUT,
      THarian,
      TLemburMakan,
      Harikeenam,
      IsShift,
      Bpjsks,
      Bpjstk,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("UpahPokok", UpahPokok);
    formData.append("Keahlian", Keahlian);
    formData.append("JkIN", JkIN);
    formData.append("JkOUT", JkOUT);
    formData.append("THarian", THarian);
    formData.append("TLemburMakan", TLemburMakan);
    formData.append("Harikeenam", Harikeenam);
    formData.append("IsShift", IsShift);
    formData.append("Bpjsks", Bpjsks);
    formData.append("Bpjstk", Bpjstk);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertMasterPayroll",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const updateMpayroll = createAsyncThunk(
  "mpayroll/update",
  async (
    {
      Nik,
      UpahPokok,
      Keahlian,
      JkIN,
      JkOUT,
      THarian,
      TLemburMakan,
      Harikeenam,
      IsShift,
      Bpjsks,
      Bpjstk,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("UpahPokok", UpahPokok);
    formData.append("Keahlian", Keahlian);
    formData.append("JkIN", JkIN);
    formData.append("JkOUT", JkOUT);
    formData.append("THarian", THarian);
    formData.append("TLemburMakan", TLemburMakan);
    formData.append("Harikeenam", Harikeenam);
    formData.append("IsShift", IsShift);
    formData.append("Bpjsks", Bpjsks);
    formData.append("Bpjstk", Bpjstk);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateMasterPayroll",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

export const insertUserClient = createAsyncThunk(
  "mpayroll/update",
  async ({ Nik, Username }, thunkAPI) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("Username", Username);

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertUserClient",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const mpayrollSlice = createSlice({
  name: "mpayroll",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinMpayroll.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinMpayroll.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload?.message || "Gagal memuat data";
    },
    [getMinMpayroll.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getMpayroll.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getMpayroll.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload?.message || "Gagal memuat data";
    },
    [getMpayroll.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertMpayroll.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      // window.location.reload(false);
      return state;
    },
    [insertMpayroll.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload?.message || "Gagal menyimpan data";
    },
    [insertMpayroll.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateMpayroll.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      // window.location.reload(false);
      return state;
    },
    [updateMpayroll.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload?.message || "Gagal menyimpan data";
    },
    [updateMpayroll.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const mpayrollSelector = (state) => state.mpayroll;
